module.exports = __webpack_public_path__ + "img/home1.2570df6d.png";